/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Cmp_Clickup_Th1Inputs */

const en_mk_cmp_clickup_th1 = /** @type {(inputs: Mk_Cmp_Clickup_Th1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The AI add-on is charged for every paid member; Business + Everything AI ≈ $40 per seat.`)
};

const id_mk_cmp_clickup_th1 = /** @type {(inputs: Mk_Cmp_Clickup_Th1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add-on AI dikenakan ke semua anggota berbayar; Business + Everything AI ≈ $40 per kursi.`)
};

/**
* | output |
* | --- |
* | "The AI add-on is charged for every paid member; Business + Everything AI ≈ $40 per seat." |
*
* @param {Mk_Cmp_Clickup_Th1Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cmp_clickup_th1 = /** @type {((inputs?: Mk_Cmp_Clickup_Th1Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cmp_Clickup_Th1Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cmp_clickup_th1(inputs)
	return en_mk_cmp_clickup_th1(inputs)
});